export const MAX_RESULT_WINDOW = 10_000;

// Visible pagination ceiling for Talent Search (ONE-6438). Recruiters never page this deep
// and the backend retrieves enough to serve it; the result count can still read higher
// ("10,000+"). Kept below MAX_RESULT_WINDOW so deep paging never hits the ES window error.
export const UI_PAGINATION_CAP = 2_000;
